/* eslint-disable @typescript-eslint/no-explicit-any */
import posthog from 'posthog-js'
import { rootUrl } from '../consts/other'
import { POST } from '../consts/methods'
import { getDeviceId } from './deviceId'
import { isPosthogReady } from './posthog'

const events = {
  dealer_open_offer: 'dealer_open_offer',
  dealer_create_bet: 'dealer_create_bet',
  dealer_create_bet_on_offer: 'dealer_create_bet_on_offer',
  dealer_set_manual_pagination: 'dealer_set_manual_pagination',
  dealer_set_infinite_pagination: 'dealer_set_infinite_pagination',
  dealer_open_filter_modal: 'dealer_open_filter_modal',
  dealer_buy_now_toggle: 'dealer_buy_now_toggle',
  dealer_distance_range_click: 'dealer_distance_range_click',
  dealer_toggle_liked: 'dealer_toggle_liked',
  dealer_liked_offers_view: 'dealer_liked_offers_view',
  dealer_type_search_input: 'dealer_type_search_input',
  dealer_filter_machine_type: 'dealer_filter_machine_type',
  dealer_global_error: 'dealer_global_error',
  dealer_fetch_offers_fail: 'dealer_fetch_offers_fail',
  dealer_api_call: 'dealer_api_call',
  dealer_meaningful_action: 'dealer_meaningful_action',
  dealer_captcha_shown: 'dealer_captcha_shown'
}

export type Events = keyof typeof events

type EventData = Record<string, any>
const track = (eventName: Events, eventData: EventData = {}, eventTags: EventData[] = []): void => {
  const userName = localStorage.getItem('dealer_email') ?? ''
  const deviceId = getDeviceId()
  const eventTagsWithAdminEmail = [
    ...eventTags,
    { dealer_email: userName.toLowerCase() },
    { platform: 'web' },
    ...(deviceId !== null && deviceId !== '' ? [{ device_id: deviceId }] : [])
  ]
  const requestParams = {
    event_name: events[eventName],
    event_tags: eventTagsWithAdminEmail,
    event_data: eventData
  }

  if (process.env.NODE_ENV !== 'development') {
    fetch(`${rootUrl}/internal-analytics/create`, {
      method: POST,
      headers: { 'Content-type': 'application/json' },
      body: JSON.stringify(requestParams)
    }).catch(null)

    if (isPosthogReady()) {
      const posthogProperties: EventData = {
        ...eventData,
        dealer_email: userName.toLowerCase(),
        platform: 'web'
      }
      if (deviceId !== null && deviceId !== '') {
        posthogProperties.device_id = deviceId
      }
      posthog.capture(events[eventName], posthogProperties)
    }
  }
}

export default track
